module.exports = __webpack_public_path__ + "static/media/geesaa_5.08cf15b1.jpg";